import { IAMPORT_KEY, IAMPORT_TIER } from '../env';

import {
  CertificationRequest,
  IamportPaymentParams,
  IamportWrapper,
} from './iamport-types';

export * from './iamport-types';

console.debug('Use actual iamport module');

const IAMPORT_SCRIPT_URL = 'https://cdn.iamport.kr/v1/iamport.js';

const iamportWrapper: IamportWrapper = {
  certificate: params => {
    const { data, callback, prefix } = params;
    const merchant_uid = `hscan${
      prefix ? '_' + prefix : ''
    }_${new Date().getTime()}`;
    const request: CertificationRequest = {
      ...data,
      merchant_uid,
    };
    window.IMP.certification(request, callback);
  },
  pay: (params: IamportPaymentParams) => {
    const { data, callback } = params;
    window.IMP.request_pay(data, callback);
  },
};

const CANCEL_IAMPORT_REQUEST = 'CANCEL_IAMPORT_REQUEST';

const globalState: {
  isPending: boolean;
  loadStarted: boolean;
  loadIamport?: Promise<void>;
} = {
  isPending: false,
  loadStarted: false,
  loadIamport: undefined,
};
export const getIamportLoader = () => {
  let subscriber: () => void | undefined;
  let localState = {
    /* if true, iamport script is not loaded yet */
    isLoading: true,
    /* if true, request is not completed yet since iamport is not loaded or currently working */
    isPending: false,
  };
  let cancel: () => void = () => undefined;

  const setLoading = (loading: boolean) => {
    if (localState.isLoading !== loading) {
      localState = {
        ...localState,
        isLoading: loading,
      };
      subscriber?.();
    }
  };
  const setPending = (pending: boolean) => {
    globalState.isPending = pending;
    if (localState.isPending !== pending) {
      localState = {
        ...localState,
        isPending: pending,
      };
      subscriber?.();
    }
  };
  return {
    subscribe: (callback: () => void) => {
      if (!globalState.loadStarted) {
        // load iamport script for first time
        globalState.loadStarted = true;

        globalState.loadIamport = new Promise(resolve => {
          const script = document.createElement('script');
          script.src = IAMPORT_SCRIPT_URL;
          script.async = true;
          script.onload = () => {
            window.IMP.init(IAMPORT_KEY);
            // window.IMP.agency(IAMPORT_KEY, IAMPORT_TIER);
            // notice subscriber
            resolve();
          };
          document.head.appendChild(script);
        });
      }
      // set subscriber
      subscriber = callback;

      // register loaded notice callback
      globalState.loadIamport?.then(() => setLoading(false));

      // callback for cleanup
      return () => {
        cancel();
        subscriber = () => {
          return;
        };
      };
    },
    execute: (call: (iamport: IamportWrapper) => void) => {
      if (globalState.isPending) {
        // ignore request during another request being processed
        return;
      }
      setPending(true);
      new Promise<void>((resolve, reject) => {
        globalState.loadIamport?.then(() => resolve());
        cancel = () => {
          reject(CANCEL_IAMPORT_REQUEST);
        };
      })
        .then(() => {
          // execute after iamport loaded
          call(iamportWrapper);
        })
        .catch(reason => {
          if (reason === CANCEL_IAMPORT_REQUEST) {
            // handle canceled request
            return;
          }
          throw reason;
        })
        .finally(() => {
          cancel = () => undefined;
          // set as completed
          setPending(false);
        });
    },
    getSnapshot: () => {
      return localState;
    },
  };
};
